import { NotificationSettings } from '../types';

export const DEFAULT_NOTIFICATION_SETTINGS: NotificationSettings = {
  reminders: {
    enabled: true,
    send_before_minutes: 1440,
    channels: ['sms']
  },
  confirmations: {
    enabled: true,
    require_customer_confirmation: true,
    auto_confirm_after_minutes: 1440,
    channels: ['sms']
  }
};

// Merge defaults with existing settings
export function mergeWithDefaults(existing: Partial<NotificationSettings>): NotificationSettings {
  return {
    reminders: {
      enabled: existing.reminders?.enabled ?? DEFAULT_NOTIFICATION_SETTINGS.reminders.enabled,
      send_before_minutes: existing.reminders?.send_before_minutes ?? DEFAULT_NOTIFICATION_SETTINGS.reminders.send_before_minutes,
      channels: existing.reminders?.channels ?? DEFAULT_NOTIFICATION_SETTINGS.reminders.channels
    },
    confirmations: {
      enabled: existing.confirmations?.enabled ?? DEFAULT_NOTIFICATION_SETTINGS.confirmations.enabled,
      require_customer_confirmation: existing.confirmations?.require_customer_confirmation ?? DEFAULT_NOTIFICATION_SETTINGS.confirmations.require_customer_confirmation,
      auto_confirm_after_minutes: existing.confirmations?.auto_confirm_after_minutes ?? DEFAULT_NOTIFICATION_SETTINGS.confirmations.auto_confirm_after_minutes,
      channels: existing.confirmations?.channels ?? DEFAULT_NOTIFICATION_SETTINGS.confirmations.channels
    }
  };
}

// Ensure notification settings exist
export async function ensureNotificationSettings(
  supabase: any,
  businessId: string
): Promise<NotificationSettings> {
  const { data, error } = await supabase
    .from('notification_settings')
    .select('settings')
    .eq('business_id', businessId)
    .maybeSingle();

  // If no settings exist, create defaults
  if (!data) {
    const { data: newData, error: insertError } = await supabase
      .from('notification_settings')
      .insert([{
        business_id: businessId,
        settings: DEFAULT_NOTIFICATION_SETTINGS
      }])
      .select()
      .single();

    if (insertError) throw insertError;
    return newData.settings;
  }

  if (error) throw error;

  // Merge with defaults to ensure all fields exist
  return mergeWithDefaults(data.settings);
}

// Validate notification settings
export function validateNotificationSettings(settings: NotificationSettings): string | null {
  if (settings.reminders.send_before_minutes < 0) {
    return 'זמן שליחת תזכורת חייב להיות חיובי';
  }

  if (settings.confirmations.auto_confirm_after_minutes < 0) {
    return 'זמן אישור אוטומטי חייב להיות חיובי';
  }

  if (settings.reminders.channels.length === 0 && settings.reminders.enabled) {
    return 'יש לבחור לפחות ערוץ אחד לתזכורות';
  }

  if (settings.confirmations.channels.length === 0 && settings.confirmations.enabled) {
    return 'יש לבחור לפחות ערוץ אחד לאישורים';
  }

  return null;
}
